import React from 'react'

import { Container } from './styles'

interface iModeDarkProps {
    modeDark?: boolean
}

const Spinner: React.FC<iModeDarkProps> = ({ modeDark }) => (
    <Container modeDark={modeDark}>
    </Container>
)


export default Spinner